import * as React from 'react';
import { useState } from 'react';
import { Box, Flex, Button, Input, FormControl, FormErrorMessage, HStack, Spacer, FormLabel } from "@chakra-ui/react"
import { Checkbox, CheckboxGroup } from '@chakra-ui/react'
import { MdSentimentNeutral } from 'react-icons/md';
import { MdSentimentVeryDissatisfied } from 'react-icons/md';
import { MdSentimentSatisfied } from 'react-icons/md';

import { IconButton } from '@chakra-ui/react'
import * as webHelpers from '../../../../../helpers/WebHelpers';
import {
    Alert,
    AlertIcon,
    AlertTitle,
    AlertDescription,
} from '@chakra-ui/react'

export interface IWorkCompletedViewProps {
    jobNumber: string;
    cb: () => void;
}

export default function WorkCompletedView(props: IWorkCompletedViewProps) {
    const [sentiment, setSentiment] = useState<number>(-1);
    const [agreed, setAgreed] = useState<boolean>(false);
    const [alert, setAlert] = useState<boolean>(false);
    const [signeeName, setSigneeName] = useState<string>("");

    const handleSubmit = () => {
        if (!agreed || !signeeName) {
            setAlert(true);
        }
        else {
            setAlert(false);
            let data = {
                satisfaction_rating: sentiment,
                signee_name: signeeName
            }
            webHelpers.postAsync('/api/sales/work/workreport/sign?job=' + props.jobNumber, data).then(res => {
                props.cb();
            }
            ).catch(err => {
                console.log(err);
            }
            )
        }
    }
    return (
        <>
            <Flex mt={5} direction='column' w='full'>
                <form onSubmit={handleSubmit}>
                <FormControl>
                <Flex ml={5} mr={5}>
                    <FormControl isInvalid={signeeName.length < 2} isRequired variant='floating'>
                        <Input value={signeeName} onChange={(e: any) => setSigneeName(e.target.value)} placeholder=' '/>
                        <FormLabel>Full Name</FormLabel>
                        <FormErrorMessage ml={2}>Full Name is required</FormErrorMessage>
                    </FormControl>
                </Flex>

                <Checkbox required mt={2} ml={7} mr={7} checked={agreed} colorScheme='green' onChange={(e: any) => setAgreed(e.target.checked)}>
                    By clicking the checkbox and submit button below, I confirm I am happy with the quality, and of the work undertaken.
                </Checkbox>
                <Flex justify='center'>
                    <Button mt={2} colorScheme='green' type="submit" disabled={!agreed || sentiment == -1} onClick={handleSubmit} justifySelf='center'>Submit</Button>
                </Flex>
                </FormControl>
                </form>
            </Flex>           

        </>
    );
}